// Topic → query keys (05-realtime § 4) — the same table as Kotlin's TopicRouter.
import { keys } from '../query/keys'

export type RealtimeAction =
  | { kind: 'invalidate'; prefixes: (readonly unknown[])[] }
  | { kind: 'reloadAppConfig' }
  | { kind: 'endSession' }

export function routeTopic(
  topic: string,
  eventType?: string,
  payloadOrgId?: string,
  thisSessionRevoked = false,
): RealtimeAction[] {
  const [stream, id, area] = topic.split(':')
  if (stream === 'org' && id && area) return [{ kind: 'invalidate', prefixes: org(id, area) }]
  if (stream === 'user' && area) return user(area, eventType, payloadOrgId, thisSessionRevoked)
  if (stream === 'broadcast' && id === 'config') return [{ kind: 'reloadAppConfig' }]
  return []
}

function org(id: string, area: string): (readonly unknown[])[] {
  switch (area) {
    case 'members':
      return [keys.orgMembers(id), keys.orgHome(id)]
    case 'teams':
      return [keys.orgTeams(id), keys.orgMembers(id)]
    case 'invitations':
      return [keys.orgInvitations(id)]
    case 'settings':
      return [keys.org(id), keys.me()]
    case 'access':
      return [keys.orgAccess(id), keys.orgPlan(id)]
    case 'tasks':
      return [keys.orgTasks(id)]
    case 'audit':
      return [keys.orgAudit(id)]
    default:
      return [keys.org(id)]
  }
}

function user(
  area: string,
  eventType: string | undefined,
  payloadOrgId: string | undefined,
  revoked: boolean,
): RealtimeAction[] {
  switch (area) {
    case 'notifications':
      return [{ kind: 'invalidate', prefixes: [keys.meNotifications(), keys.meUnread()] }]
    case 'access':
      return payloadOrgId ? [{ kind: 'invalidate', prefixes: [keys.orgAccess(payloadOrgId)] }] : []
    case 'sessions':
      return [
        { kind: 'invalidate', prefixes: [keys.meSessions()] },
        ...(eventType === 'session.revoked' && revoked ? [{ kind: 'endSession' } as const] : []),
      ]
    case 'invitations':
      return [{ kind: 'invalidate', prefixes: [keys.meInvitations(), keys.me()] }]
    default:
      return [{ kind: 'invalidate', prefixes: [keys.me()] }]
  }
}
